import {
  authorize, batchexport, batchimport, disable, enable, get, getByCode, getByUuid32, getResourceKeys, permissionBatchExport, permissionBatchImport,
  getResources, getTestresourceKeys, modify, query, queryMenu,
  queryreport, save, saveAndAuthorize, testauthorize, updateReportConfig
} from '@/services/account/Company';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'company',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/basic/article") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    showPage: '',
    currentIndex: 0,
    menus: {
      'WEB': [],
      'RF': [],
      'SCC': []
    },//菜单结构
    bigData: {},//大数据菜单
  },
  effects: {
    *query({ payload }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records,
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },
    *add({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *updateReportConfig({ payload, callback }, { call, put }) {
      const response = yield call(updateReportConfig, payload);
      if (callback) callback(response);
    },
    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            showDetailView: true,
            company: response.data,
            showDetailEditForm: false,
          }
        });
      }
      if (callback) callback(response);
    },
    *getCompany({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            company: response.data,
          }
        });
      }
      if (callback) callback(response);
    },
    *permissionBatchExport({ payload, callback }, { call, put }) {
      const response = yield call(permissionBatchExport, payload);
      if (callback) callback(response);
    },
    *permissionBatchImport({ payload, callback }, { call, put }) {
      const response = yield call(permissionBatchImport, payload);
      if (callback) callback(response);
    },
    *getByUuid32({ payload, callback }, { call, put }) {
      const response = yield call(getByUuid32, payload);
      if (callback) callback(response);
    },
    *getByUuid32({ payload, callback }, { call, put }) {
      const response = yield call(getByCode, payload);
      if (callback) callback(response);
    },
    *enable({ payload, callback }, { call, put }) {
      const response = yield call(enable, payload);
      if (callback) callback(response);
    },
    *disable({ payload, callback }, { call, put }) {
      const response = yield call(disable, payload);
      if (callback) callback(response);
    },
    *authorize({ payload, callback }, { call, put }) {
      const response = yield call(authorize, payload);
      if (callback) callback(response);
    },
    *testauthorize({ payload, callback }, { call, put }) {
      const response = yield call(testauthorize, payload);
      if (callback) callback(response);
    },
    *onView({ payload }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            showDetailView: true,
            company: response.data
          }
        });
      }
    },
    *onCancel({ payload, callback }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          showDetailView: false,
        }
      });
      if (callback) callback();
    },
    *onViewCreate({ payload, callback }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          showCreateView: true,
        }
      });
    },
    *onCancelCreate({ payload, callback }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          showCreateView: false
        }
      });
      if (callback) callback();
    },
    *getResourceKeys({ payload, callback }, { call, put }) {
      const response = yield call(getResourceKeys, payload);
      if (callback) callback(response);
    },
    *getResources({ payload, callback }, { call, put }) {
      const response = yield call(getResources, payload);
      if (callback) callback(response);
    },

    *saveAndAuthorize({ payload, callback }, { call, put }) {
      const response = yield call(saveAndAuthorize, payload);
      if (callback) callback(response);
    },
    *queryMenu({ payload, callback }, { call, put }) {
      const response = yield call(queryMenu, payload);
      if (response && response.success) {
        yield put({
          type: 'saveMenu',
          payload: response.data
        });
      }
      if (callback) callback(response);
    },
    *showPage({ payload, callback }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
      });
      if (callback) callback();
    },
    *saveStepIndex({ payload }, { call, put }) {
      yield put({
        type: 'saveIndex',
        payload: {
          currentIndex: payload.currentIndex
        }
      })
    },
    *queryreport({ payload, callback }, { call, put }) {
      const response = yield call(queryreport);
      if (callback) callback(response);
    },
    *batchimport({ payload, callback }, { call, put }) {
      const response = yield call(batchimport, payload);
      if (callback) callback(response);
    },
    *getTestresourceKeys({ payload, callback }, { call, put }) {
      const response = yield call(getTestresourceKeys, payload);
      if (callback) callback(response);
    },
    *batchexport({ payload, callback }, { call, put }) {
      const response = yield call(batchexport, payload);
      if (callback) callback(response);
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
      }
    },
    saveMenu(state, action) {
      return {
        ...state,
        menus: action.payload,
      };
    },
    saveIndex(state, action) {
      return {
        ...state,
        currentIndex: action.payload.currentIndex,
      }
    },
    saveBigdata(state, action) {
      return {
        ...state,
        bigData: action.payload.bigData
      }
    }
  },
};
